import {useCallback, useState} from 'react';

import {ProcedurePageContext} from 'procedures/ProcedurePageContext';

export interface UseSelectedStepInputs {
  defaultStepCidForMethodCidMap: {[methodCid: string]: string | null};
}

export interface UseSelectedStepOutputs {
  selectedStepCid: string | null;
  onChangeSelectedStep: (stepCid: string) => void;
}

/**
 * Simple tool to keep track of the selected step for each method in the procedure.
 */
export default function useSelectedStep(params: UseSelectedStepInputs): UseSelectedStepOutputs {
  const {selectedMethodCid} = ProcedurePageContext.useContext();
  const [selectedStepCidForMethodCid, setSelectedStepCidForMethodCid] = useState(
    params.defaultStepCidForMethodCidMap
  );

  const onChangeSelectedStep = useCallback(
    (stepCid: string): void => {
      if (selectedMethodCid != null) {
        setSelectedStepCidForMethodCid((current) => ({...current, [selectedMethodCid]: stepCid}));
      }
    },
    [selectedMethodCid]
  );

  return {
    selectedStepCid: selectedStepCidForMethodCid[selectedMethodCid ?? ''] ?? null,
    onChangeSelectedStep,
  };
}
